import Vue from 'vue';
import VueSVGIcon from 'vue-svgicon'

import Generator from './Generator.vue';
import Services from './Services.vue';

Vue.use(VueSVGIcon, {
	classPrefix: 'w-vsvg',
});

Vue.config.productionTip = false;

new Vue({
	render: h => h(Generator),
}).$mount('#generator');

new Vue({
	render: h => h(Services),
}).$mount('#services');

// ---------------------------------------------------------------------

import { throttle/*, debounce*/ } from 'tiny-throttle';

// const intro = document.querySelector('.w-intro__inner');
const part1 = document.querySelector('[data-w-part="1"]');
const part2 = document.querySelector('[data-w-part="2"]');
const part3 = document.querySelector('[data-w-part="3"]');
const part4 = document.querySelector('[data-w-part="4"]');

const initialSpeed = 0.015;
// const idleSpeed = 0.05;
const offsetFactor = 4;

let speed = initialSpeed;
let mousePosition = [0, 0];
let normalizePosition = [0, 0];

const moveHandler = throttle((event) => {
	mousePosition[0] = -0.5 + (event.clientX / window.innerWidth);
	mousePosition[1] = -0.5 + (event.clientY / window.innerHeight);
}, 50);

document.addEventListener('mousemove', moveHandler);

// ---------------------------------------------------------------------

const mapValue = (num, in_min, in_max, out_min, out_max) => {
	return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

const orientationFactor = 1;
let deviceCanReadOrientation = false;

const handleOrientation = throttle((event) => {

	if (deviceCanReadOrientation === false) {
		deviceCanReadOrientation = true;
		document.removeEventListener('mousemove', moveHandler);
	}

	let x = event.gamma*-1;
	let y = event.beta;

	if (y > 90) y = 90;
	if (y < -90) y = -90;

	x = mapValue(x, -90, 90, 0, window.innerWidth);
	y = mapValue(y, -90, 90, 0, window.innerHeight);

	mousePosition[0] = (-0.5 + (x / window.innerWidth))*orientationFactor;
	mousePosition[1] = (-0.5 + (y / window.innerHeight))*orientationFactor;

}, 50);
window.addEventListener('deviceorientation', handleOrientation, true);

// ---------------------------------------------------------------------

// intro.addEventListener('mouseenter', () => {
// 	document.removeEventListener('mousemove', moveHandler);
// 	speed = idleSpeed;
// 	mousePosition[0] = 0;
// 	mousePosition[1] = 0;
// });
// intro.addEventListener('mouseleave', () => {
// 	speed = initialSpeed;
// 	document.addEventListener('mousemove', moveHandler);
// });

// ---------------------------------------------------------------------

// function getDocHeight() {
// 	var D = document;
// 	return Math.max(
// 		D.body.scrollHeight, D.documentElement.scrollHeight,
// 		D.body.offsetHeight, D.documentElement.offsetHeight,
// 		D.body.clientHeight, D.documentElement.clientHeight
// 	)
// }

const overlayBefore = document.querySelector('.w-body__overlay--before');
const overlayAfter = document.querySelector('.w-body__overlay--after');

let scrollPercentage = null;
const updateScroll = () => {
	const winheight= window.innerHeight || (document.documentElement || document.body).clientHeight;
	// const docheight = getDocHeight();
	const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
	const trackLength = /*docheight - */winheight*0.5;
	scrollPercentage = Math.min(Math.floor(scrollTop/trackLength * 100)/100, 1); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

}
document.addEventListener('scroll', updateScroll);
updateScroll();

const navigationLogo = document.querySelector('.w-navigation__logo');
const navigationItems = document.querySelector('.w-navigation__items');

const mix = function(color_1, color_2, weight) {
	const d2h = function(d) {
		return d.toString(16);
	} // convert a decimal value to hex
	const h2d = function(h) {
		return parseInt(h, 16);
	} // convert a hex value to decimal

	weight = (typeof(weight) !== 'undefined') ? weight : 50; // set the weight to 50%, if that argument is omitted
	let color = "#";

	for(let i = 0; i<=5; i += 2) { // loop through each of the 3 hex pairs—red, green, and blue
		const v1 = h2d(color_1.substr(i, 2)); // extract the current pairs
		const v2 = h2d(color_2.substr(i, 2));

		// combine the current pairs from each source color, according to the specified weight
		let val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));

		while(val.length < 2) {
			val = '0' + val;
		} // prepend a '0' if val results in a single digit

		color += val; // concatenate val to our new color string
	}

	return color; // PROFIT!
};

function render() {
	requestAnimationFrame(render);

	normalizePosition[0] += (mousePosition[0] - normalizePosition[0]) * speed;
	normalizePosition[1] += (mousePosition[1] - normalizePosition[1]) * speed;

	part1.style.transform = `translateX(${-normalizePosition[0]*offsetFactor}rem) translateY(${normalizePosition[1]*offsetFactor*1.5}rem)`;
	part2.style.transform = `translateX(${normalizePosition[0]*offsetFactor}rem) translateY(${-normalizePosition[1]*offsetFactor*1.5}rem)`;
	part3.style.transform = `translateX(${normalizePosition[0]*offsetFactor}rem) translateY(${-normalizePosition[1]*offsetFactor*1.5}rem)`;
	part4.style.transform = `translateX(${-normalizePosition[0]*offsetFactor}rem) translateY(${normalizePosition[1]*offsetFactor*1.5}rem)`;

	// ---------------------------------------------------------------------

	overlayAfter.style.opacity = scrollPercentage;
	overlayBefore.style.opacity = scrollPercentage;

	// ---------------------------------------------------------------------

	// if (deviceCanReadOrientation === false) {
	// 	const proximity = mapValue(mousePosition[1], -0.5, 0.5, 3, -3);
	// 	navigationItems.style.opacity = proximity;
	// }

	const color = mix('141238', 'FFFFFF', scrollPercentage*100);
	navigationItems.style.color = color;
	navigationLogo.style.color = color;

}
render();
